import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CommentService from "../../../services/comment";
import CommentForm from "../CommentForm";
import CommentItem from "../CommentItem";
import { showErrorToaster } from "../../../adminCompenents/listComponents/UI/toaster/error";
import "./index.scss";

const commentService = new CommentService();

const CommentsSection = () => {
  const { id } = useParams();
  const [comments, setComments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const loadComments = async () => {
    try {
      setIsLoading(true);
      const commentsData = await commentService.getCommentsByProduct(id);
      setComments(commentsData);
    } catch (error) {
      showErrorToaster("Erreur lors du chargement des commentaires");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadComments();
  }, [id]);

  const handleCommentAdded = (newComment) => {
    setComments(prevComments => [newComment, ...prevComments]);
  };

  const handleCommentUpdated = (commentId, updatedText) => {
    setComments(prevComments =>
      prevComments.map(comment =>
        comment._id === commentId
          ? { ...comment, comment: updatedText }
          : comment
      )
    );
  };

  const handleCommentDeleted = (commentId) => {
    setComments(prevComments =>
      prevComments.filter(comment => comment._id !== commentId)
    );
  };

  return (
    <div className="comments-section my-5">
      <div className="comments">
        <h3 className="mb-4">COMMENTAIRES</h3>
        
        {/* Comment Form */}
        <CommentForm 
          productId={id} 
          onCommentAdded={handleCommentAdded}
        />

        {/* Comments List */}
        {isLoading ? (
          <div className="loading-comments">
            <p>Chargement des commentaires...</p>
          </div>
        ) : comments.length > 0 ? (
          <div className="comments-list">
            {comments.map((comment) => (
              <CommentItem
                key={comment._id}
                comment={comment}
                onUpdate={handleCommentUpdated}
                onDelete={handleCommentDeleted}
              />
            ))}
          </div>
        ) : (
          <div className="no-comments">
            <p>Aucun commentaire pour ce produit. Soyez le premier à laisser un avis !</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommentsSection;
